import { memo } from 'react';

import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useAccessView } from 'hooks/tournaments/accessView';
import { useRole } from 'hooks/useRole';
import PropTypes from 'prop-types';

const PageAccessController = ({
  Element,
  feature,
  isEnabled,
  disabledFallback,
}) => {
  const role = useRole();
  const hasTournamentsAccess = useAccessView();
  const featureEnabled = useFeatureIsOn(feature);

  if (
    isEnabled &&
    !isEnabled({
      role,
      hasTournamentsAccess,
      featureEnabled,
    })
  ) {
    return disabledFallback;
  }

  return <Element />;
};

PageAccessController.propTypes = {
  Element: PropTypes.elementType.isRequired,
  feature: PropTypes.string,
  isEnabled: PropTypes.func,
  disabledFallback: PropTypes.any,
};

export default memo(PageAccessController);
